/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ProjectRigisHeader,
  RigisColumnProperties,
  RigisColumnZippedValues,
  RigisColumnsParameters,
  RigisCreation,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class RigisClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Rigis
   * @summary Вернёт метаинформацию для всех возможных колонок РИГИС
   * @request GET:/geology/rigis/columns_meta
   * @secure
   */
  rigisGetColumnsProperties = (params: RequestParams = {}) =>
    this.http.request<RigisColumnProperties[], any>({
      path: `/geology/rigis/columns_meta`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Rigis
   * @summary Получение заголовков РИГИС по идентификатору месторождения.
   * @request POST:/geology/rigis/headers_by_field/{fieldId}
   * @secure
   */
  rigisGetRigisHeadersByIds = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<ProjectRigisHeader[], any>({
      path: `/geology/rigis/headers_by_field/${fieldId}`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Rigis
 * @summary По идентификаторам ригис и именам колонок вернёт сжатые значения, упорядоченные по глубине в соответствии с колонкой TopDepth.
Если данные по колонке ригис не пришли, значит их нет в БД.
 * @request POST:/geology/rigis/get_zipped_values
 * @secure
 */
  rigisGetZippedValues = (data: RigisColumnsParameters, params: RequestParams = {}) =>
    this.http.request<RigisColumnZippedValues[], any>({
      path: `/geology/rigis/get_zipped_values`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Rigis
 * @summary Создание новой записи РИГИС.
Коллекция строк с данными не должна содержать строк с дубликатами по глубине.
 * @request POST:/geology/rigis
 * @secure
 */
  rigisAddRigis = (data: RigisCreation, params: RequestParams = {}) =>
    this.http.request<string, string>({
      path: `/geology/rigis`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
